import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

// Define keyframes for the glow animation
const pulseAnimation = `
  @keyframes pulse-glow {
    0% {
      box-shadow: 0 0 15px 1px rgba(138, 43, 226, 0.4);
    }
    50% {
      box-shadow: 0 0 20px 2px rgba(138, 43, 226, 0.6), 0 0 15px 3px rgba(138, 43, 226, 0.2);
    }
    100% {
      box-shadow: 0 0 15px 1px rgba(138, 43, 226, 0.4);
    }
  }
`;

const BookTrainingButton = ({ user }) => {
  const [isChiliPiperLoaded, setIsChiliPiperLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // Inject the animation keyframes into the document
    if (!document.getElementById('pulse-glow-animation')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'pulse-glow-animation';
      styleEl.innerHTML = pulseAnimation;
      document.head.appendChild(styleEl);
    }

    // Check if ChiliPiper is loaded
    if (window.ChiliPiper) {
      setIsChiliPiperLoaded(true);
    }

    // Set up responsive behavior
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkScreenSize();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);
    
    const handleChiliPiperLoaded = () => {
      setIsChiliPiperLoaded(true);
    };

    window.addEventListener('ChiliPiperLoaded', handleChiliPiperLoaded);

    if (!document.querySelector('script[src*="chilipiper.in/concierge-js"]')) {
      const script = document.createElement('script');
      script.src = 'https://theticketfairy.chilipiper.com/concierge-js/cjs/concierge.js';
      script.type = 'text/javascript';
      script.async = true;
      script.onload = () => {
        window.dispatchEvent(new Event('ChiliPiperLoaded'));
      };
      document.head.appendChild(script);
    }

    return () => {
      window.removeEventListener('ChiliPiperLoaded', handleChiliPiperLoaded);
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const handleBooking = () => {
    if (window.ChiliPiper) {
      try {
        window.ChiliPiper.submit("theticketfairy", "onboarding-router", {
          map: true,
          trigger: 'InAppButton',
          lead: {
            PersonEmail: user.email,
            PersonFirstName: user.firstName,
            PersonLastName: user.lastName,
            // Force this required question to show in the form:
            "b77615a6-68ab-4b56-943f-e571429403c6": ""
          }
        });
      } catch (error) {
        console.error('Error calling ChiliPiper:', error);
      }
    } else {
      console.warn('ChiliPiper is not loaded yet');
      alert('Booking system is currently unavailable. Please try again later.');
    }
  };

  return (
    <div style={{ 
      position: 'relative', 
      display: 'inline-block',
      borderRadius: '4px',
      margin: 0
    }}>
      <button 
        className="btn btn-primary booking-button" 
        onClick={handleBooking}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px 16px',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          backgroundColor: isHovered ? '#7823c7' : '#8a2be2', // Beautiful purple color
          color: 'white',
          border: 'none',
          boxShadow: isHovered 
            ? '0 0 12px 3px rgba(138, 43, 226, 0.4), 0 0 18px 4px rgba(138, 43, 226, 0.2)' 
            : '0 0 5px 1px rgba(138, 43, 226, 0.2)',
          transition: 'all 0.3s ease',
          letterSpacing: '0.5px',
          margin: 0,
          animation: isHovered ? 'none' : 'pulse-glow 3s infinite ease-in-out',
          transform: isHovered ? 'scale(1.02)' : 'scale(1)',
          position: 'relative',
          zIndex: 1
        }}
        onMouseOver={() => setIsHovered(true)}
        onMouseOut={() => setIsHovered(false)}
      >
        <FontAwesomeIcon 
          icon={faCalendarAlt} 
          style={{ 
            marginRight: '8px',
            fontSize: '14px'
          }} 
        />
        {isMobile ? 'Need Help? Book Training Call' : 'Need Help? Book On-Boarding / Training Call'}
      </button>
    </div>
  );
};

export const UnconnectedBookTrainingButton = BookTrainingButton;

export default connect(
  state => ({
    user: _get(state, 'auth.user', {}),
  })
)(BookTrainingButton);
